import 'intersection-observer';

export class SectionObserver {

    constructor(){}


    init() {

        window.addEventListener('load', (event) => {

            const observer = new window.IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.target.classList.contains('is-visible')) {
                        return;
                    }

                    entry.target.classList[entry.isIntersecting ? 'add' : 'remove']('is-visible');

                    // if (entry.isIntersecting) {
                    //     entry.target.classList.add('is-visible');
                    // } else {
                    //     entry.target.classList.remove('is-visible');
                    // }

                });
            });

            const elements = Array.prototype.slice.call(document.querySelectorAll('section:not(.is-visible)'));

            elements.forEach(el => {
                observer.observe(el);
            });
        });
    }
}
